<template>
  <div id="cancel-modal">
    <button
      type="button"
      class="button-secundary ml-2 mr-2 pl-3 pr-3"
      @click="$emit('click')"
    >
      <span class="cta">
        <slot></slot>
      </span>
    </button>
  </div>
</template>
<script>
export default {
  name: "no-del-modal",
  props: {
    disabled: {
      default: true,
      type: Boolean,
    },
  },
  emits: ["click:emit"],
  data() {
    return {};
  },
  beforeMount() {},
  methods: {},
};
</script>
<style lang="scss">
#cancel-modal {
}
</style>